module.exports = __webpack_public_path__ + "e0106718/img/upload-icon.9179ae4e.svg";